module Pki {
    export class Error {
        constructor(msg: string, type = ErrorType.Undefined) {
            this.msg = msg;
            this.type = type;
        }

        msg: string;
        type: number;
    }
}